export default "__VITE_ASSET__c44748c2__"